import { takeLatest, put, call } from 'redux-saga/effects';

import * as actions from '../actions';
import requext from '../../utils/requext';
import graphFetch from '../../util/graphFetch';
import {
    GET_COUNTRIES_REQUEST,
    GET_COUNTRIES_SUCCESS,
    GET_TEMPLATES_SUCCESS,
    GET_TEMPLATE_REQUEST,
    GET_TEMPLATES_REQUEST,
    MAKE_TEMPLATE_REQUEST,
    MAKE_TEMPLATE_SUCCESS,
    MAKE_TEMPLATE_FAILURE,
} from '../actionTypes';

function* getCountries() {
    const query = {
        query: `query {
            getCountries {
                country
            }
        }`,
    };
    const resp = yield requext(undefined, JSON.stringify(query));
    const { data } = yield resp.json();
    if (data.getCountries) {
        yield put({
            type: GET_COUNTRIES_SUCCESS,
            countries: data.getCountries,
        });
    }
}

function* getTemplates() {
    const query = {
        query: `query {
            templates {
                id title type category layout thumbnail
            }
        }`,
    };
    const resp = yield requext(undefined, JSON.stringify(query));
    const { data } = yield resp.json();
    if (data.templates) {
        yield put({
            type: GET_TEMPLATES_SUCCESS,
            templates: data.templates,
        });
    }
}

function* makeTemplate({ siteId, template }) {
    const { title, ...rest } = template;
    try {
        const mutation = true;
        const options = {
            queryName: 'createTemplate',
            select: `status
            message
            success
            template {
                id 
                title 
                layout
                type
                thumbnail 
            }`,
            args: {
                siteId: { type: 'ID', value: siteId },
                title: { type: 'String!', value: title },
                ...rest,
            },
        };

        const { data } = yield call(graphFetch, options, mutation);
        if (data && data.createTemplate && data.createTemplate.success) {
            yield put({
                type: MAKE_TEMPLATE_SUCCESS,
                payload: data.createTemplate,
            });
        } else {
            const payload = {
                message: data
                    ? data.createTemplate
                        ? data.createTemplate.message
                        : 'Something went wrong'
                    : 'Something went wrong',
            };
            yield put({ type: MAKE_TEMPLATE_FAILURE, payload });
        }
    } catch (err) {}
}

function* getTemplate({ id }) {
    try {
        const options = {
            queryName: 'template',
            select: 'data title id',
            args: {
                id: { type: 'ID!', value: id },
            },
        };

        const { data } = yield call(graphFetch, options);
        if (data && data.template) {
            yield put(actions.getTemplateSuccess(data.template));
        }
    } catch (err) {
        console.log(err);
    }
}

export default [
    takeLatest(GET_COUNTRIES_REQUEST, getCountries),
    takeLatest(GET_TEMPLATES_REQUEST, getTemplates),
    takeLatest(MAKE_TEMPLATE_REQUEST, makeTemplate),
    takeLatest(GET_TEMPLATE_REQUEST, getTemplate),
];
